import React, { useState, useEffect } from "react";
import RetreatApi from "../api/retreatApi";
import { toast } from "react-toastify";
import AlertModal from "../components/AlertModal";
import { Form } from "react-bootstrap";
import TalksApi from "../api/talksApi";
import { checkImageExists } from "../helpers/checkImageExists";

interface ConfirmationsProps {
  retreatHeading?: Record<string, any> | null;
  setSelectedRetreat: (id: any) => void;
  setRetreatHeading: (data: any) => void;
  handleConfirmStatus: () => void;
  setIncommingRetreats: React.Dispatch<React.SetStateAction<any[]>>;
  userData?: Record<string, any> | null;
  missingDataLength?: number;
  retreatRoastData?: Array<Record<string, any>>;
}

const Confirmations: React.FC<ConfirmationsProps> = ({
  retreatHeading,
  setSelectedRetreat,
  setRetreatHeading,
  handleConfirmStatus,
  setIncommingRetreats,
  userData,
  missingDataLength,
  retreatRoastData,
}) => {
  let retreatApi = new RetreatApi();
  let talksApi = new TalksApi();
  const [confirmation, setConfirmation] = useState<any[]>([]);
  const [talksDataList, setTalksDataList] = useState<any[]>([]);

  useEffect(() => {
    getTalksList();
  }, []);

  const getTalksList = async () => {
    await talksApi
      .getAllTalkList({} as any)
      .then(async (response: any) => {
        const sortedList = response.data.sort((a: any, b: any) =>
          a.talk.localeCompare(b.talk),
        );
        setTalksDataList(sortedList);
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const confirmAlert = async (retreatData: any, item: string) => {
    const toggles = [
      { name: "roasterData" },
      { name: "Directory" },
      { name: "Program" },
      { name: "pictures" },
    ];
    const confirmationIndex = toggles.findIndex((t) => t.name === item);
    const isAlreadyConfirmed =
      retreatData?.confirmation?.[confirmationIndex]?.[item];

    if (isAlreadyConfirmed) {
      if (item === "Directory") {
        toast.info("Directory is already published. Not allowed to unconfirm.");
        return;
      } else if (item === "Program") {
        toast.info("Program is already published. Not allowed to unconfirm.");
        return;
      } else if (item === "pictures") {
        toast.info("All Pictures are uploaded. Not allowed to unconfirm.");
        return;
      } else if (item === "roasterData") {
        toast.info(
          "All Retreat Roster rules are confirmed. Not allowed to unconfirm.",
        );
        return;
      }
    }

    // 1) ROSTER DATA
    if (item === "roasterData") {
      if (missingDataLength !== 0) {
        toast.error("Please complete missing roster data before confirming.");
        return;
      }
      // const assignedTalkIds = retreatRoastData
      //   .map((r) => r.talkId)
      //   .filter(Boolean);
      // // Check if Spiritual Director exists
      // const hasSpiritualDirector = retreatRoastData.some(
      //   (r) => r.mainRole === "Spiritual Director"
      // );
      // // Required talks based on Spiritual Director presence
      // const requiredTalksCount = hasSpiritualDirector ? 11 : 10;
      // // 1. Validate required talks count
      // if (assignedTalkIds.length !== requiredTalksCount) {
      //   toast.error(
      //     `All ${requiredTalksCount} required talks must be assigned before confirming roster data.`
      //   );
      //   return;
      // }
      // 3. Ensure no duplicate talks
      // const uniqueTalks = new Set(assignedTalkIds);
      // if (uniqueTalks.size !== requiredTalksCount) {
      //   toast.error("Each talk can only be assigned once.");
      //   return;
      // }

      // // 4. Ensure all Team members have a Service Title assigned
      // const teamMembers = retreatRoastData.filter(
      //   (r) => r.attendeeType === "Team"
      // );
      // const teamMembersWithoutService = teamMembers.filter(
      //   (r) => !r.service || r.service === null || r.service === ""
      // );
      // if (teamMembersWithoutService.length > 0) {
      //   toast.error(
      //     `${teamMembersWithoutService.length} Team member(s) are missing a Service Title. Please assign a service before confirming roster data.`
      //   );
      //   return;
      // }

      // 5. Ensure exactly 6 couples have Role "Head", Sub-Role "Co-Head", and a Service Title
      // const headCoHeadWithService = retreatRoastData.filter(
      //   (r) =>
      //     r.mainRole === "Head" &&
      //     r.subRole === "Co-Head" &&
      //     r.service &&
      //     r.service !== null &&
      //     r.service !== ""
      // );
      // if (headCoHeadWithService.length !== 6) {
      //   toast.error(
      //     `Exactly 6 couples must have Role "Head", Sub-Role "Co-Head", and a Service Title assigned. Currently ${headCoHeadWithService.length} couple(s) meet this retreat.`
      //   );
      //   return;
      // }
    }
    // 2) DIRECTORY
    if (item === "Directory") {
      const directoryExists =
        retreatData?.directoryFile && retreatData.directoryFile !== "";

      const isDirectoryPublished = retreatData?.directoryStatus === "PUBLISH";

      if (!directoryExists && !isDirectoryPublished) {
        toast.error("Please upload or publish Directory before confirmation.");
        return;
      }
    }

    // 3) PROGRAM
    if (item === "Program") {
      const programExists =
        retreatData?.programFile && retreatData.programFile !== "";

      const isProgramPublished = retreatData?.programStatus === "PUBLISH";

      if (!programExists && !isProgramPublished) {
        toast.error("Please upload or publish Program before confirmation.");
        return;
      }
    }

    // 4) PICTURES
    if (item === "pictures") {
      if (!retreatRoastData || retreatRoastData.length === 0) {
        toast.error("No couples found.");
        return;
      }

      // Step 1: Check if URLs exist
      const couplesWithoutUrl = retreatRoastData.filter(
        (r) => !r?.imageUrl || r.imageUrl.trim() === "",
      );

      if (couplesWithoutUrl.length > 0) {
        toast.error(
          `${couplesWithoutUrl.length} couple(s) are missing pictures. Please upload all images before confirming.`,
        );
        return;
      }

      const imageResults = await Promise.all(
        retreatRoastData.map((r) => checkImageExists(r.imageUrl)),
      );

      const brokenImages = retreatRoastData.filter(
        (r, index) => !imageResults[index],
      );

      if (brokenImages.length > 0) {
        const brokenNames = brokenImages
          .slice(0, 3)
          .map((r) => `${r.hisFirstName} ${r.hisLastName}`)
          .join(", ");

        toast.error(
          `${brokenImages.length} couple(s) have broken images. Please upload all images before confirming.`,
        );
        return;
      }

      toast.success("All images verified successfully!");
    }

    if (item === "Directory") {
      setConfirmation([
        { retreatData: retreatData, item: "Directory", userData: userData },
      ]);
    } else if (item === "Program") {
      setConfirmation([
        { retreatData: retreatData, item: "Program", userData: userData },
      ]);
    } else if (item === "pictures") {
      setConfirmation([
        { retreatData: retreatData, item: "pictures", userData: userData },
      ]);
    } else {
      setConfirmation([
        { retreatData: retreatData, item: "roasterData", userData: userData },
      ]);
    }
  };

  const closeConfirmAlert = () => {
    setConfirmation([]);
  };

  const handleConfirmation = () => {
    retreatApi
      .handleConfirmation(confirmation)
      .then(async (res: any) => {
        if (res.success) {
          toast.success(res.message);
          closeConfirmAlert();
          handleConfirmStatus();
          setSelectedRetreat(res.data.id);
          setRetreatHeading(res.data);
          setIncommingRetreats((prevRetreats) =>
            prevRetreats.map((item) =>
              item.id === res.data.id ? { ...item, ...res.data } : item,
            ),
          );
        } else {
          toast.error(res.message);
          closeConfirmAlert();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const toggles = [
    {
      name: "roasterData",
      id: "roasterData",
      label: retreatHeading?.confirmation?.[0]?.roasterData
        ? "Confirmed Roster Data"
        : "Confirm Roster Data",
    },
    {
      name: "Directory",
      id: "directory",
      label: retreatHeading?.confirmation?.[1]?.Directory
        ? "Confirmed Directory"
        : "Confirm Directory",
    },
    {
      name: "Program",
      id: "program",
      label: retreatHeading?.confirmation?.[2]?.Program
        ? "Confirmed Program"
        : "Confirm Program",
    },
    {
      name: "pictures",
      id: "pictures",
      label: retreatHeading?.confirmation?.[3]?.pictures
        ? "Confirmed the Pictures"
        : "Confirm the Pictures",
    },
  ];

  const CONFIRM_MESSAGES: Record<string, string> = {
    Directory:
      "Are you sure you want to confirm the directory for this retreat?",
    Program: "Are you sure you want to confirm the Program for this retreat?",
    roasterData:
      "Are you sure you want to confirm the Roster Data for this retreat?",
    pictures:
      "Are you sure you want to confirm the pictures for this retreat?",
  };

  const confirmItem = confirmation[0]?.item;

  return (
    <div className="circles_Confirmations">
      <div className="circles2_Confirmations">
        {toggles.map((toggle) => (
          <div className="d-flex leftSideButtons" key={toggle.id}>
            <Form.Check
              disabled={
                retreatHeading?.freeze === "FREEZE" ||
                Boolean(retreatHeading?.retreatCloseStatus)
              }
              className={`switchSize confirm-toggle ${
                retreatHeading?.confirmation?.[toggles.indexOf(toggle)]?.[
                  toggle.name
                ]
                  ? "toggle-on"
                  : "toggle-off-confirm"
              }`}
              type="switch"
              name={toggle.name}
              value={
                retreatHeading?.confirmation?.[toggles.indexOf(toggle)]?.[
                  toggle.name
                ] || false
              }
              checked={
                retreatHeading?.confirmation?.[toggles.indexOf(toggle)]?.[
                  toggle.name
                ] || false
              }
              onChange={() => confirmAlert(retreatHeading, toggle.name)}
              id={toggle.id}
            />
            <h6
              className={`default ${
                retreatHeading?.confirmation?.[toggles.indexOf(toggle)]?.[
                  toggle.name
                ]
                  ? "confirmLabel"
                  : "noConfirmLabel"
              }`}
            >
              <a>{toggle.label}</a>
            </h6>
            {toggle.name === "Directory" && retreatHeading?.directoryFile && (
              <a
                href={retreatHeading.directoryFile}
                target="_blank"
                rel="noopener noreferrer"
                className="ms-2"
              >
                <i
                  title="Download Directory"
                  className="mdi mdi-download"
                  style={{ color: "#4cd964", fontSize: "1.2rem" }}
                ></i>
              </a>
            )}
            {toggle.name === "Program" && retreatHeading?.programFile && (
              <a
                href={retreatHeading.programFile}
                target="_blank"
                rel="noopener noreferrer"
                className="ms-2"
              >
                <i
                  title="Download Program"
                  className="mdi mdi-download"
                  style={{ color: "#4cd964", fontSize: "1.2rem" }}
                ></i>
              </a>
            )}
          </div>
        ))}
      </div>

      {confirmItem ? (
        <AlertModal
          cancel={"Cancel"}
          okay={"Okay"}
          show={Boolean(confirmItem)}
          handleClose={closeConfirmAlert}
          message={CONFIRM_MESSAGES[confirmItem]}
          actionFunction={handleConfirmation}
          heading={"ALERT!!"}
        />
      ) : null}
    </div>
  );
};

export default Confirmations;
